{
  "nativeNotifications.permissionDenied": "Android notification permission is off; in-app reminders still appear here.",
  "nativeNotifications.permissionEnabled": "Android notifications are enabled",
  "nativeNotifications.permissionPrompt": "Show due reminders as Android notifications too.",
  "nativeNotifications.permissionUnsupported": "This Android device cannot show system notifications; in-app reminders still appear here.",
  "nativeActions.title": "Reminder action",
  "nativeActions.description": "Review the latest server state before Exognitos changes anything.",
  "nativeActions.reviewTitle": "Confirm action",
  "nativeActions.invalid": "This notification action is unavailable",
  "nativeActions.invalidDescription": "Its bounded identifier or revision is missing. Open Notifications to review the current reminder.",
  "nativeActions.taskUnavailable": "The linked task could not be loaded",
  "nativeActions.reminderOnly": "This action applies to the reminder occurrence.",
  "nativeActions.taskChanged": "The task changed after this notification was created. Open it and review the current state instead.",
  "nativeActions.actions": "Reminder actions",
  "nativeActions.complete": "Complete task",
  "nativeActions.snooze": "Snooze 15 minutes",
  "nativeActions.dismiss": "Dismiss reminder",
  "nativeActions.schedule": "Open scheduling",
  "nativeActions.back": "Back to Notifications",
  "nativeActions.failed": "The action could not be applied. Review the current reminder state and try again.",
  "nativeActions.success.complete_task": "Task completed.",
  "nativeActions.success.snooze_15m": "Reminder snoozed for 15 minutes.",
  "nativeActions.success.acknowledge": "Reminder dismissed."
}
